import React, { Suspense, lazy } from 'react';
import HomeBanner from './HomeBanner';
import RouteLoading from '../../components/RouteLoading';

const lazyOnClient = (importer, serverLoader) => {
  if (typeof window === "undefined") {
    const module = serverLoader();
    return module.default || module;
  }

  return lazy(importer);
};

const HomeBlog = lazyOnClient(() => import('./HomeBlog'), () => require('./HomeBlog'));
const HomeClient = lazyOnClient(() => import('./HomeClient'), () => require('./HomeClient'));
const HomeCounter = lazyOnClient(() => import('./HomeCounter'), () => require('./HomeCounter'));
const HomeKey = lazyOnClient(() => import('./HomeKey'), () => require('./HomeKey'));
const HomeLogos = lazyOnClient(() => import('./HomeLogos'), () => require('./HomeLogos'));
const HomePlatform = lazyOnClient(() => import('./HomePlatform'), () => require('./HomePlatform'));
const HomeSolutions = lazyOnClient(() => import('./HomeSolutions'), () => require('./HomeSolutions'));
const HomeTab = lazyOnClient(() => import('./HomeTab'), () => require('./HomeTab'));
const TeamSection = lazyOnClient(() => import('./HomeTeam'), () => require('./HomeTeam'));
const HomeTeam2 = lazyOnClient(() => import('./HomeTeam2'), () => require('./HomeTeam2'));

export default function Home({initialData}) {
  return (
<>
<HomeBanner/>
<Suspense fallback={<RouteLoading />}>
  <HomeLogos/>
  <HomeCounter/>
  <TeamSection/>
  <HomeSolutions/>
  <HomeTab/>
  <HomeTeam2/>
  <HomeKey/>
  <HomePlatform/>
  <HomeClient/>
  <HomeBlog initialData={initialData}/>
</Suspense>
</>
  )
}
